import { useEffect } from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/vr/PublicLayout";
import Home from "@/pages/Home";
import { ClassesList, ClassDetail } from "@/pages/Classes";
import { SubjectsList, SubjectDetail } from "@/pages/Subjects";
import { NotesList, NoteReader } from "@/pages/Notes";
import { QuizList, QuizPlayer, TestPlayer } from "@/pages/Quiz";
import { VideosList } from "@/pages/Videos";
import { BlogList, BlogPost } from "@/pages/Blog";
import EnglishCourse from "@/pages/EnglishCourse";
import Search from "@/pages/Search";
import { Contact, About, Privacy, Terms, Disclaimer, Refund, Copyright, NotFound } from "@/pages/StaticPages";
import { TestsList, ImportantQuestions, PreviousYear } from "@/pages/Extras";
import { AdminLogin, AdminApp } from "@/pages/Admin";

function App() {
  useEffect(() => {
    if (!document.getElementById("rzp-script")) {
      const s = document.createElement("script");
      s.id = "rzp-script"; s.src = "https://checkout.razorpay.com/v1/checkout.js"; s.async = true;
      document.body.appendChild(s);
    }
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            {/* Canonical short-URL routes (SEO-friendly) */}
            <Route path="/class-9" element={<ClassDetail />} />
            <Route path="/class-10" element={<ClassDetail />} />
            <Route path="/class-11" element={<ClassDetail />} />
            <Route path="/class-12" element={<ClassDetail />} />
            <Route path="/mcq" element={<QuizList />} />
            <Route path="/youtube" element={<VideosList />} />
            {/* Existing routes (kept so old links / bookmarks keep working) */}
            <Route path="/classes" element={<ClassesList />} />
            <Route path="/classes/:slug" element={<ClassDetail />} />
            <Route path="/subjects" element={<SubjectsList />} />
            <Route path="/subjects/:slug" element={<SubjectDetail />} />
            <Route path="/notes" element={<NotesList />} />
            <Route path="/notes/:slug" element={<NoteReader />} />
            <Route path="/mcq-quiz" element={<QuizList />} />
            <Route path="/quiz/:slug" element={<QuizPlayer />} />
            <Route path="/test/:slug" element={<TestPlayer />} />
            <Route path="/online-tests" element={<TestsList />} />
            <Route path="/important-questions" element={<ImportantQuestions />} />
            <Route path="/previous-year-questions" element={<PreviousYear />} />
            <Route path="/youtube-classes" element={<VideosList />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/english-course" element={<EnglishCourse />} />
            <Route path="/search" element={<Search />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/copyright" element={<Copyright />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
